import { render, staticRenderFns } from "./RemindersView.vue?vue&type=template&id=964e39ae&scoped=true"
import script from "./RemindersView.vue?vue&type=script&lang=js"
export * from "./RemindersView.vue?vue&type=script&lang=js"
import style0 from "./RemindersView.vue?vue&type=style&index=0&id=964e39ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964e39ae",
  null
  
)

export default component.exports